// DO NOT EDIT -- generated from fs/services/dx-objects/dashboards.proto

import { OrgToOrgDxObjectCopyResponse } from './copy.proto';
import { Card, Dashboard, VirtualDashboard } from './model.proto';
import { UnnamedOverlay } from './overlays.proto';
import * as accesscontrol from '../../shared/accesscontrol';
import * as protoauditstore from '../../gcloud/dstore/protoauditstore';
import * as protobuf from '../../../google/protobuf';

export namespace DashboardsPublic {

  export const GetAllDashboardsEndpoint = "/grpc/dx_objects.DashboardsPublic/GetAllDashboards";
  /**
   * GetAllDashboards accepts machine and non-machine contexts. If it is called with a machine context, it will not filter
   * out unowned private objects. If it is called with a session, it will filter out private objects not owned by the email
   * address provided in the request.
   */
  export function GetAllDashboards(sender: (req: GetAllDashboardsRequest, endpoint: string) => Promise<GetAllDashboardsResponse>, req: GetAllDashboardsRequest): { promise: () => Promise<GetAllDashboardsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllDashboardsEndpoint),
      endpoint: GetAllDashboardsEndpoint
    };
  }

  export const GetDashboardEndpoint = "/grpc/dx_objects.DashboardsPublic/GetDashboard";
  export function GetDashboard(sender: (req: GetDashboardRequest, endpoint: string) => Promise<GetDashboardResponse>, req: GetDashboardRequest): { promise: () => Promise<GetDashboardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDashboardEndpoint),
      endpoint: GetDashboardEndpoint
    };
  }

  export const GetInitialDashboardsEndpoint = "/grpc/dx_objects.DashboardsPublic/GetInitialDashboards";
  export function GetInitialDashboards(sender: (req: GetInitialDashboardsRequest, endpoint: string) => Promise<GetInitialDashboardsResponse>, req: GetInitialDashboardsRequest): { promise: () => Promise<GetInitialDashboardsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInitialDashboardsEndpoint),
      endpoint: GetInitialDashboardsEndpoint
    };
  }

  export const CreateDashboardEndpoint = "/grpc/dx_objects.DashboardsPublic/CreateDashboard";
  export function CreateDashboard(sender: (req: CreateDashboardRequest, endpoint: string) => Promise<CreateDashboardResponse>, req: CreateDashboardRequest): { promise: () => Promise<CreateDashboardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateDashboardEndpoint),
      endpoint: CreateDashboardEndpoint
    };
  }

  export const DeleteDashboardEndpoint = "/grpc/dx_objects.DashboardsPublic/DeleteDashboard";
  export function DeleteDashboard(sender: (req: DeleteDashboardRequest, endpoint: string) => Promise<{}>, req: DeleteDashboardRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteDashboardEndpoint),
      endpoint: DeleteDashboardEndpoint
    };
  }

  export const BulkDeleteDashboardsEndpoint = "/grpc/dx_objects.DashboardsPublic/BulkDeleteDashboards";
  export function BulkDeleteDashboards(sender: (req: BulkDeleteDashboardsRequest, endpoint: string) => Promise<BulkDeleteDashboardsResponse>, req: BulkDeleteDashboardsRequest): { promise: () => Promise<BulkDeleteDashboardsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BulkDeleteDashboardsEndpoint),
      endpoint: BulkDeleteDashboardsEndpoint
    };
  }

  export const UpdateDashboardEndpoint = "/grpc/dx_objects.DashboardsPublic/UpdateDashboard";
  export function UpdateDashboard(sender: (req: UpdateDashboardRequest, endpoint: string) => Promise<UpdateDashboardResponse>, req: UpdateDashboardRequest): { promise: () => Promise<UpdateDashboardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateDashboardEndpoint),
      endpoint: UpdateDashboardEndpoint
    };
  }

  export const StarDashboardEndpoint = "/grpc/dx_objects.DashboardsPublic/StarDashboard";
  export function StarDashboard(sender: (req: StarDashboardRequest, endpoint: string) => Promise<{}>, req: StarDashboardRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, StarDashboardEndpoint),
      endpoint: StarDashboardEndpoint
    };
  }

  export const MarkDashboardViewedEndpoint = "/grpc/dx_objects.DashboardsPublic/MarkDashboardViewed";
  export function MarkDashboardViewed(sender: (req: MarkDashboardViewedRequest, endpoint: string) => Promise<{}>, req: MarkDashboardViewedRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, MarkDashboardViewedEndpoint),
      endpoint: MarkDashboardViewedEndpoint
    };
  }

  export const DuplicateDashboardEndpoint = "/grpc/dx_objects.DashboardsPublic/DuplicateDashboard";
  export function DuplicateDashboard(sender: (req: DuplicateDashboardRequest, endpoint: string) => Promise<DuplicateDashboardResponse>, req: DuplicateDashboardRequest): { promise: () => Promise<DuplicateDashboardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DuplicateDashboardEndpoint),
      endpoint: DuplicateDashboardEndpoint
    };
  }

  export const GetAllCardsEndpoint = "/grpc/dx_objects.DashboardsPublic/GetAllCards";
  export function GetAllCards(sender: (req: GetAllCardsRequest, endpoint: string) => Promise<GetAllCardsResponse>, req: GetAllCardsRequest): { promise: () => Promise<GetAllCardsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllCardsEndpoint),
      endpoint: GetAllCardsEndpoint
    };
  }

  export const GetCardEndpoint = "/grpc/dx_objects.DashboardsPublic/GetCard";
  export function GetCard(sender: (req: GetCardRequest, endpoint: string) => Promise<GetCardResponse>, req: GetCardRequest): { promise: () => Promise<GetCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetCardEndpoint),
      endpoint: GetCardEndpoint
    };
  }

  export const CreateCardEndpoint = "/grpc/dx_objects.DashboardsPublic/CreateCard";
  export function CreateCard(sender: (req: CreateCardRequest, endpoint: string) => Promise<CreateCardResponse>, req: CreateCardRequest): { promise: () => Promise<CreateCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateCardEndpoint),
      endpoint: CreateCardEndpoint
    };
  }

  export const UpdateCardEndpoint = "/grpc/dx_objects.DashboardsPublic/UpdateCard";
  export function UpdateCard(sender: (req: UpdateCardRequest, endpoint: string) => Promise<UpdateCardResponse>, req: UpdateCardRequest): { promise: () => Promise<UpdateCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateCardEndpoint),
      endpoint: UpdateCardEndpoint
    };
  }

  export const DeleteCardEndpoint = "/grpc/dx_objects.DashboardsPublic/DeleteCard";
  export function DeleteCard(sender: (req: DeleteCardRequest, endpoint: string) => Promise<DeleteCardResponse>, req: DeleteCardRequest): { promise: () => Promise<DeleteCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteCardEndpoint),
      endpoint: DeleteCardEndpoint
    };
  }

  export const DuplicateCardEndpoint = "/grpc/dx_objects.DashboardsPublic/DuplicateCard";
  export function DuplicateCard(sender: (req: DuplicateCardRequest, endpoint: string) => Promise<DuplicateCardResponse>, req: DuplicateCardRequest): { promise: () => Promise<DuplicateCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, DuplicateCardEndpoint),
      endpoint: DuplicateCardEndpoint
    };
  }

  export const MoveCardEndpoint = "/grpc/dx_objects.DashboardsPublic/MoveCard";
  export function MoveCard(sender: (req: MoveCardRequest, endpoint: string) => Promise<MoveCardResponse>, req: MoveCardRequest): { promise: () => Promise<MoveCardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, MoveCardEndpoint),
      endpoint: MoveCardEndpoint
    };
  }

  export const GetDashboardsAccessEndpoint = "/grpc/dx_objects.DashboardsPublic/GetDashboardsAccess";
  export function GetDashboardsAccess(sender: (req: accesscontrol.CanAccessRequest, endpoint: string) => Promise<accesscontrol.CanAccessResponse>, req: accesscontrol.CanAccessRequest): { promise: () => Promise<accesscontrol.CanAccessResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetDashboardsAccessEndpoint),
      endpoint: GetDashboardsAccessEndpoint
    };
  }

  export const TransferDashboardOwnerEndpoint = "/grpc/dx_objects.DashboardsPublic/TransferDashboardOwner";
  export function TransferDashboardOwner(sender: (req: TransferDashboardOwnerRequest, endpoint: string) => Promise<{}>, req: TransferDashboardOwnerRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, TransferDashboardOwnerEndpoint),
      endpoint: TransferDashboardOwnerEndpoint
    };
  }

  export const CreateFromVirtualDashboardEndpoint = "/grpc/dx_objects.DashboardsPublic/CreateFromVirtualDashboard";
  export function CreateFromVirtualDashboard(sender: (req: CreateFromVirtualDashboardRequest, endpoint: string) => Promise<CreateFromVirtualDashboardResponse>, req: CreateFromVirtualDashboardRequest): { promise: () => Promise<CreateFromVirtualDashboardResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CreateFromVirtualDashboardEndpoint),
      endpoint: CreateFromVirtualDashboardEndpoint
    };
  }
}

/**
 * DashboardsPublic merges saved Dashboards with user-specific data like the user's last viewed timestamp.
 * This internal service only fetches saved Dashboards and does not attach user-specific data, similar
 * to the search-settings services for other objects. This is useful for internal callers that do not care about
 * user-specific data.
 */
export namespace Dashboards {

  export const GetAllDashboardsInternalEndpoint = "/grpc/dx_objects.Dashboards/GetAllDashboardsInternal";
  export function GetAllDashboardsInternal(sender: (req: GetAllDashboardsInternalRequest, endpoint: string) => Promise<GetAllDashboardsResponse>, req: GetAllDashboardsInternalRequest): { promise: () => Promise<GetAllDashboardsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllDashboardsInternalEndpoint),
      endpoint: GetAllDashboardsInternalEndpoint
    };
  }

  export const GetAllCardsInternalEndpoint = "/grpc/dx_objects.Dashboards/GetAllCardsInternal";
  export function GetAllCardsInternal(sender: (req: GetAllCardsInternalRequest, endpoint: string) => Promise<GetAllCardsResponse>, req: GetAllCardsInternalRequest): { promise: () => Promise<GetAllCardsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAllCardsInternalEndpoint),
      endpoint: GetAllCardsInternalEndpoint
    };
  }

  export const CopyDashboardsToOrgEndpoint = "/grpc/dx_objects.Dashboards/CopyDashboardsToOrg";
  export function CopyDashboardsToOrg(sender: (req: CopyDashboardsToOrgRequest, endpoint: string) => Promise<OrgToOrgDxObjectCopyResponse>, req: CopyDashboardsToOrgRequest): { promise: () => Promise<OrgToOrgDxObjectCopyResponse>, endpoint: string } {
    return {
      promise: () => sender(req, CopyDashboardsToOrgEndpoint),
      endpoint: CopyDashboardsToOrgEndpoint
    };
  }
}

export interface GetAllDashboardsInternalRequest {
  orgId: string;
  email: string;
}

export interface GetAllDashboardsRequest {
  orgId: string;
  email: string;
  /**
   * If true, do not include fill out starred or recently viewed. This will omit
   * the gRPC call to seat-settings.
   */
  omitSeatSettings: boolean;
}

export interface GetAllDashboardsResponse {
  dashboards: Dashboard[];
}

export interface GetDashboardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
}

export interface GetDashboardResponse {
  dashboard: Dashboard | null;
}

export interface GetInitialDashboardsRequest {
  orgId: string;
}

export interface GetInitialDashboardsResponse {
  starred: Dashboard[];
  recent: Dashboard[];
}

export interface CreateDashboardRequest {
  orgId: string;
  dashboard: Dashboard | null;
}

export interface CreateDashboardResponse {
  dashboard: Dashboard | null;
}

export interface DeleteDashboardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
}

export interface BulkDeleteDashboardsRequest {
  orgId: string;
  dashboards: DeleteDashboardRequest[];
}

export interface BulkDeleteDashboardsResponse {
  failedDashboardIds: protobuf.int64[];
}

export interface UpdateDashboardRequest {
  orgId: string;
  dashboard: Dashboard | null;
}

export interface UpdateDashboardResponse {
  dashboard: Dashboard | null;
}

export interface StarDashboardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  starred: boolean;
}

export interface MarkDashboardViewedRequest {
  orgId: string;
  dashboardId: protobuf.int64;
}

export interface DuplicateDashboardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  visibility: protoauditstore.Visibility;
}

export interface DuplicateDashboardResponse {
  dashboard: Dashboard | null;
}

export interface GetAllCardsRequest {
  orgId: string;
  dashboardId: protobuf.int64;
}

export interface GetAllCardsInternalRequest {
  orgId: string;
  dashboardId: protobuf.int64;
}

export interface GetAllCardsResponse {
  cards: Card[];
}

export interface GetCardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  cardId: protobuf.int64;
  overlay: UnnamedOverlay | null;
}

export interface GetCardResponse {
  dashboard: Dashboard | null;
  card: Card | null;
}

export interface CreateCardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  card: Card | null;
  /** insert_at = nil or out of bounds appends a new card at the end */
  insertAt: protobuf.int64 | null;
}

export interface CreateCardResponse {
  dashboard: Dashboard | null;
  card: Card | null;
}

export interface UpdateCardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  card: Card | null;
}

export interface UpdateCardResponse {
  dashboard: Dashboard | null;
  card: Card | null;
}

export interface DeleteCardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  cardId: protobuf.int64;
}

export interface DeleteCardResponse {
  dashboard: Dashboard | null;
}

export interface TransferDashboardOwnerRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  owners: string[];
}

export interface DuplicateCardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  cardId: protobuf.int64;
  toDashboardId: protobuf.int64;
  name: string;
  description: string;
}

export interface DuplicateCardResponse {
  dashboard: Dashboard | null;
  card: Card | null;
  originalCard: Card | null;
}

export interface MoveCardRequest {
  orgId: string;
  dashboardId: protobuf.int64;
  cardId: protobuf.int64;
  toIndex: number;
}

export interface MoveCardResponse {
  dashboard: Dashboard | null;
}

export interface CreateFromVirtualDashboardRequest {
  orgId: string;
  virtualDashboard: VirtualDashboard | null;
  name: string;
  description: string;
  overlay: UnnamedOverlay | null;
  spaceId: string;
  visibility: protoauditstore.Visibility;
  sectionId: string;
}

export interface CreateFromVirtualDashboardResponse {
  dashboard: Dashboard | null;
}

export interface CopyDashboardsToOrgRequest {
  sourceOrgId: string;
  destinationOrgId: string;
  dashboardIds: string[];
  /** source_id -> destination_id */
  segmentMappings: { [key: string]: string };
  /** source_id -> destination_id */
  metricsMappings: { [key: string]: string };
  /** source_id -> destination_id */
  funnelMappings: { [key: string]: string };
  /** source_id -> destination_id */
  heatmapMappings: { [key: string]: string };
  /** source_id -> destination_id */
  retentionMappings: { [key: string]: string };
}
